var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1435_214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.4167,
    height: 38,
    fill: "#016FD0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1435_214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.4167,
    height: 38,
    rx: 4,
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7793 29.0708V20.3525H20.0103L21.0007 21.6436L22.0238 20.3525H55.5301V28.4695C55.5301 28.4695 54.6539 29.0621 53.6405 29.0708H35.0873L33.9707 27.6965V29.0708H30.3116V26.7248C30.3116 26.7248 29.8118 27.0523 28.7312 27.0523H27.4857V29.0708H21.9455L20.9566 27.752L19.9524 29.0708H10.7793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.7817L2.08163 8.92871H5.68159L6.86294 11.6472V8.92871H11.338L12.0413 10.8935L12.7231 8.92871H32.8115V9.91649C32.8115 9.91649 33.8676 8.92871 35.6031 8.92871L42.1211 8.95149L43.282 11.6344V8.92871H47.027L48.0577 10.4698V8.92871H51.8371V17.647H48.0577L47.07 16.1009V17.647H41.5678L41.0144 16.2726H39.5353L38.9909 17.647H35.2595C33.7662 17.647 32.8115 16.6793 32.8115 16.6793V17.647H27.1855L26.0689 16.2726V17.647H5.14828L4.59533 16.2726H3.12087L2.57184 17.647H0V13.7817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81743 10.0029L0.00976562 16.5309H1.8377L2.35575 15.2237H5.36741L5.88278 16.5309H7.75097L4.94599 10.0029H2.81743ZM3.85621 11.5222L4.7742 13.8064H2.93553L3.85621 11.5222V11.5222Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94336 16.5299V10.002L10.541 10.0116L12.0518 14.2204L13.5265 10.002H16.1033V16.5299H14.4713V11.7198L12.7414 16.5299H11.3101L9.57535 11.7198V16.5299H7.94336Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2227 16.53V10.002H22.5481V11.4622H18.8718V12.5788H22.4622V13.9531H18.8718V15.1127H22.5481V16.53H17.2227Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4902 10.0029V16.5309H25.1222V14.2118H25.8094L27.7662 16.5309H29.7606L27.6132 14.1259C28.4945 14.0515 29.4036 13.2951 29.4036 12.1208C29.4036 10.7471 28.3253 10.0029 27.122 10.0029H23.4902V10.0029ZM25.1222 11.4631H26.9878C27.4353 11.4631 27.7608 11.8132 27.7608 12.1503C27.7608 12.584 27.339 12.8375 27.0119 12.8375H25.1222V11.4631V11.4631Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7386 16.53H30.0723V10.002H31.7386V16.53Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6898 16.53H35.3302C33.5898 16.53 32.5332 15.1589 32.5332 13.2928C32.5332 11.3806 33.578 10.002 35.7757 10.002H37.5795V11.5481H35.7098C34.8176 11.5481 34.1867 12.2443 34.1867 13.3089C34.1867 14.5731 34.9081 15.1041 35.9475 15.1041H36.377L35.6898 16.53Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2413 10.0029L36.4336 16.5309H38.2615L38.7796 15.2237H41.7912L42.3066 16.5309H44.1748L41.3698 10.0029H39.2413ZM40.28 11.5222L41.198 13.8064H39.3594L40.28 11.5222Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3633 16.53V10.002H46.4382L49.0875 14.1034V10.002H50.7195V16.53H48.7117L45.9953 12.3211V16.53H44.3633Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8965 27.9538V21.4258H17.222V22.886H13.5457V24.0026H17.1361V25.3769H13.5457V26.5365H17.222V27.9538H11.8965Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9902 27.9538V21.4258H43.3157V22.886H39.6394V24.0026H43.2126V25.3769H39.6394V26.5365H43.3157V27.9538H37.9902Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4289 27.9537L20.0219 24.73L17.3672 21.4258H19.4233L21.0043 23.4684L22.5906 21.4258H24.5662L21.9464 24.6898L24.5441 27.9537H22.4884L20.9533 25.9433L19.4555 27.9537H17.4289Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7363 21.4268V27.9548H26.4113V25.8933H28.1292C29.5828 25.8933 30.6845 25.1221 30.6845 23.6224C30.6845 22.3801 29.8204 21.4268 28.3412 21.4268H24.7363V21.4268ZM26.4113 22.9031H28.2204C28.69 22.9031 29.0257 23.1909 29.0257 23.6547C29.0257 24.0903 28.6917 24.4062 28.2151 24.4062H26.4113V22.9031Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3945 21.4258V27.9538H33.0265V25.6346H33.7137L35.6705 27.9538H37.6649L35.5175 25.5487C36.3988 25.4744 37.3079 24.718 37.3079 23.5436C37.3079 22.1699 36.2296 21.4258 35.0263 21.4258H31.3945V21.4258ZM33.0265 22.886H34.8921C35.3396 22.886 35.6651 23.2361 35.6651 23.5732C35.6651 24.0069 35.2433 24.2603 34.9162 24.2603H33.0265V22.886V22.886Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0725 27.9538V26.5365H47.3386C47.8219 26.5365 48.0311 26.2754 48.0311 25.989C48.0311 25.7145 47.8225 25.4371 47.3386 25.4371H45.8627C44.5797 25.4371 43.8652 24.6554 43.8652 23.4819C43.8652 22.4352 44.5195 21.4258 46.426 21.4258H49.6041L48.9169 22.8946H46.1683C45.6429 22.8946 45.4811 23.1703 45.4811 23.4336C45.4811 23.7042 45.681 24.0026 46.0824 24.0026H47.6285C49.0587 24.0026 49.6792 24.8139 49.6792 25.8762C49.6792 27.0183 48.9877 27.9538 47.5507 27.9538H44.0725Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0607 27.9538V26.5365H53.3269C53.8102 26.5365 54.0194 26.2754 54.0194 25.989C54.0194 25.7145 53.8108 25.4371 53.3269 25.4371H51.851C50.568 25.4371 49.8535 24.6554 49.8535 23.4819C49.8535 22.4352 50.5078 21.4258 52.4143 21.4258H55.5275L54.9052 22.8946H52.1566C51.6312 22.8946 51.4694 23.1703 51.4694 23.4336C51.4694 23.7042 51.6693 24.0026 52.0707 24.0026H53.6168C55.0469 24.0026 55.6675 24.8139 55.6675 25.8762C55.6675 27.0183 54.976 27.9538 53.5389 27.9538H50.0607Z",
    fill: "#016FD0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.519a999f7a34b12055a0d3745cc22f70.svg";
export { ForwardRef as ReactComponent };